import { z } from '@hono/zod-openapi'

export const zPagination = z.object({
    page: z.coerce.number().optional(),
    size: z.coerce.number().optional(),
})

export const zCommonQuery = z
    .object({
        search: z.string().optional(),
        orderBy: z.string().optional(),
        sortOrder: z.enum(['asc', 'desc']).optional(),
    })
    .extend(zPagination.shape)

export const zPassword = z
    .string()
    .min(8)
    .max(64)
    .regex(/[A-Z]/, 'Must contain at least one uppercase letter')
    .regex(/[0-9]/, 'Must contain at least one number')
    .regex(/[^A-Za-z0-9\s]/, 'Must contain at least one special character')

export type CommonQueryParams = z.infer<typeof zCommonQuery>
export type PaginationParams = z.infer<typeof zPagination>
